import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const LineDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.line16-9_svg__cls-1{fill:#fff}.line16-9_svg__cls-3{fill:#424242}.line16-9_svg__cls-4{fill:#eee}.line16-9_svg__cls-5{fill:none;stroke:#f5f5f5;stroke-miterlimit:10}.line16-9_svg__cls-6{fill:#9e9e9e}'
        }
      </style>
    </defs>
    <g id="line16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="line16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path className="line16-9_svg__cls-1" d="M6.28 39.65h131.78v52.92H6.28z" />
        <path
          d="M138 39.65v-18a14.29 14.29 0 00-14.25-14.32h-14.1v1.92a7.58 7.58 0 01-7.57 7.59h-59a7.58 7.58 0 01-7.58-7.59V7.33H20.56A14.3 14.3 0 006.28 21.64v18z"
          fill="#263147"
        />
        <circle className="line16-9_svg__cls-3" cx={19.26} cy={80.14} r={6.62} />
        <path className="line16-9_svg__cls-4" d="M29.62 74.31h34.37v3.94H29.62zM29.62 81.01H51.7v3.94H29.62z" />
        <path
          className="line16-9_svg__cls-1"
          d="M6.28 134.41v144.83a14.31 14.31 0 0014.31 14.31h103.1A14.31 14.31 0 00138 279.24V134.41z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path className="line16-9_svg__cls-5" d="M6.41 259.03h131.36M6.41 58.94h131.36" />
        <circle className="line16-9_svg__cls-6" cx={20.18} cy={270.75} r={5.23} />
        <circle className="line16-9_svg__cls-6" cx={25.45} cy={49.53} r={5.23} />
        <circle className="line16-9_svg__cls-6" cx={67.59} cy={49.53} r={5.23} />
        <circle className="line16-9_svg__cls-6" cx={109.73} cy={49.53} r={5.23} />
        <circle className="line16-9_svg__cls-6" cx={45.34} cy={270.75} r={5.23} />
        <circle className="line16-9_svg__cls-3" cx={70.51} cy={270.75} r={5.23} />
        <circle className="line16-9_svg__cls-6" cx={95.67} cy={270.75} r={5.23} />
        <circle className="line16-9_svg__cls-6" cx={16.47} cy={29.75} r={4.62} />
        <circle className="line16-9_svg__cls-6" cx={127.11} cy={29.75} r={4.62} />
        <circle className="line16-9_svg__cls-6" cx={120.83} cy={270.75} r={5.23} />
        <path fill="#1ca64d" d="M6.13 92.99h131.9v73.1H6.13z" />
        <path className="line16-9_svg__cls-4" d="M13.14 63.79h55.23V68H13.14zM13.14 174.02h55.23v4.21H13.14z" />
        <rect x={104.49} y={171.18} width={28.09} height={9.87} rx={2.89} fill="#5384e6" />
        <circle className="line16-9_svg__cls-3" cx={19.26} cy={197.22} r={6.62} />
        <path
          className="line16-9_svg__cls-4"
          d="M12.79 242h8.63v3.94h-8.63zM12.79 212.04H135.4v4.21H12.79zM12.79 232.25H135.4v4.21H12.79zM12.79 221.6H130.7v4.21H12.79z"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default LineDevice169;
